import { z } from 'zod';
export const TimeEntryStatusSchema = z.enum(['UNBILLED', 'BILLED', 'NON_BILLABLE']);
export const TimeEntryStatusLabel = {
    UNBILLED: 'Sin facturar',
    BILLED: 'Facturado',
    NON_BILLABLE: 'No facturable',
};
export const TimeEntryDtoSchema = z.object({
    id: z.string(),
    caseId: z.string(),
    caseCode: z.string(),
    caseTitle: z.string(),
    clientId: z.string(),
    clientDisplayName: z.string(),
    userId: z.string(),
    userName: z.string(),
    taskId: z.string().nullable(),
    taskTitle: z.string().nullable(),
    description: z.string(),
    performedOn: z.string().datetime(),
    durationMinutes: z.number().int(),
    startedAt: z.string().datetime().nullable(),
    endedAt: z.string().datetime().nullable(),
    hourlyRateCents: z.number().int(),
    amountCents: z.number().int(),
    status: TimeEntryStatusSchema,
    invoiceLineId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const CreateTimeEntrySchema = z.object({
    caseId: z.string(),
    taskId: z.string().nullable().optional(),
    description: z.string().min(1).max(1000),
    performedOn: z.string().refine((v) => !Number.isNaN(Date.parse(v)), 'Fecha no válida'),
    /** Duración en minutos. Si se usó cronómetro, se calcula client-side desde start/end. */
    durationMinutes: z.coerce.number().int().min(1).max(24 * 60),
    startedAt: z.string().nullable().optional(),
    endedAt: z.string().nullable().optional(),
    /** Override de tarifa (en céntimos/hora). Si null, se calcula del usuario/firm. */
    hourlyRateCents: z.coerce.number().int().min(0).optional(),
    /** Forzar status NON_BILLABLE al crear (ej. interno). */
    nonBillable: z.boolean().default(false),
});
export const UpdateTimeEntrySchema = z.object({
    description: z.string().min(1).max(1000).optional(),
    performedOn: z
        .string()
        .refine((v) => !Number.isNaN(Date.parse(v)), 'Fecha no válida')
        .optional(),
    durationMinutes: z.coerce.number().int().min(1).max(24 * 60).optional(),
    hourlyRateCents: z.coerce.number().int().min(0).optional(),
    status: TimeEntryStatusSchema.optional(),
});
export const TimeEntryListQuerySchema = z.object({
    caseId: z.string().optional(),
    clientId: z.string().optional(),
    userId: z.string().optional(),
    status: TimeEntryStatusSchema.optional(),
    mine: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((v) => v === true || v === 'true')
        .optional(),
    from: z.string().optional(),
    to: z.string().optional(),
});
export const TimeEntryListResponseSchema = z.object({
    items: z.array(TimeEntryDtoSchema),
    totalMinutes: z.number().int(),
    totalAmountCents: z.number().int(),
});
export const ImportTimeEntriesSchema = z.object({
    timeEntryIds: z.array(z.string()).min(1).max(200),
    /** Si true, agrupa todas las entradas de la misma causa en una sola línea. */
    groupByCase: z.boolean().default(false),
});
//# sourceMappingURL=time-entries.js.map